import { hasPermissionAction } from "../../../shared/components/layout/sidebar/utils/permissions.js";

/**
 * @param {import("../constants/mobile-tabbar-tabs-config.js").MobileTabItem[]} tabs
 * @param {Object[]} userRoles
 * @param {number} maxVisibleTabs
 * @returns {import("../constants/mobile-tabbar-tabs-config.js").MobileTabItem[]}
 */
export function filterVisibleMobileTabs(tabs, userRoles, maxVisibleTabs) {
  const items = Array.isArray(tabs) ? tabs : [];

  const visible = items
    .filter((tab) => {
      if (!tab.permission) {
        return true;
      }

      return hasPermissionAction(
        userRoles,
        tab.permission,
        tab.action || "islist",
      );
    })
    .sort((a, b) => a.priority - b.priority);

  return visible.slice(0, maxVisibleTabs);
}
